var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-selected_task"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "selected_task",
    clipPath: "url(#clip-selected_task)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CheckmarkDavidSelected",
    transform: "translate(-30.992 -44.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(38.992 52.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 292,
    cy: 292,
    r: 292,
    fill: "#633fda"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000024688917951254936150000008386693706061424544_",
    transform: "translate(152.961 216.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M131.06,295.031c83.456-51.361,174.563-137.292,251.8-200.012-12.2-13.087-24.869-37.286-37.065-50.127-2.152-2.222-4.543-4.692-7.652-4.692-2.63,0-5.261,1.729-7.413,3.457C268.319,93.29,208.059,167.368,138.951,206.877c-3.587,1.975-7.652,3.951-11.717,2.963-3.587-.988-6.217-3.951-8.609-6.914-10.522-13.087-17.217-29.138-27.5-42.472-5.261-6.667-9.326-9.877-13.152-10.865-6.935-1.729-13.391,4.2-23.674,12.593-8.848,7.161-18.652,12.84-27.5,20,25.826,25.187,57.152,72.844,82.977,98.031,2.87,2.963,10.522,14.816,14.587,15.31",
    transform: "translate(-26.8 -40.2)",
    fill: "#fff"
  }))))));
};
export default __webpack_public_path__ + "static/media/selected_task.e3af90e0.svg";
export { SvgComponent as ReactComponent };